import React, { Fragment, useEffect, useState } from "react";
import { Tabs } from "antd";

import { MapContainer, TileLayer } from "react-leaflet";
import "leaflet/dist/leaflet.css";

import { Row, Col } from "reactstrap";
import SideBar from "../../components/SideBar";
import Header from "../../components/OperationManagement/Header";

import OperationCardList from "../../components/OperationManagement/OperationCardList";

import MapComponent from "../../components/OperationManagement/MapComponent";

import {
  getAllPlanifiedOperationApi,
  getAllCurrentOperationApi,
  getAllFinishedOperationApi,
  countAllPlanifiedOperationApi,
  countAllCurrentOperationApi,
  countAllFinishedOperationApi
} from "./../../api/operationManagemment"

const STATUS_COLORS = {
  planifie: '#8a94a6',
  enCours: '#fb6340',
  termine: '#1cbcb4',
}

function OperationManagement() {
  const position = [30.379245, -9.520939];

  const [startPosition, setStartPosition] = useState({})
  const [endPosition, setEndPosition] = useState({})
  const [hasSelectedRoute, setHasSelectedRoute] = useState(false)

  const [countedPlanifiedData, setCountedPlanifiedData] = useState([])
  const [countedCurrentData, setCountedCurrentData] = useState([])
  const [countedFinishedData, setCountedFinishedData] = useState([])

  const [refreshTrigger, setRefreshTrigger] = useState(0)

  useEffect(() => {
    getInitialData()
    // eslint-disable-next-line
  }, [refreshTrigger])

  const handleOperationChanged = () => {
    setRefreshTrigger(prev => prev + 1)
  }

  const getInitialData = async () => {
    try {
      const P = await countAllPlanifiedOperationApi()
      const E = await countAllCurrentOperationApi()
      const T = await countAllFinishedOperationApi()

      setCountedPlanifiedData(P)
      setCountedCurrentData(E)
      setCountedFinishedData(T)
    }
    catch(err) {

    }
  }

  const onChange = (key) => {};

  const handleShowOrderDirection = (data) => {
    setStartPosition(data.startPosition)
    setEndPosition(data.endPosition)
    setHasSelectedRoute(true)
  }

  const tabsData = [
    {
      label: (
        <div className="tabLabel">
          <span className="tabDot" style={{ backgroundColor: STATUS_COLORS.planifie }}></span>
          <div>
            <b>Planifiés</b>
            <p>{countedPlanifiedData.numberOfOp || 0} {parseInt(countedPlanifiedData.numberOfOp) >= 2 ? 'opérations' : 'opération'}</p>
          </div>
        </div>
      ),
      key: 1,
      children: <OperationCardList fetchOperations={getAllPlanifiedOperationApi} statusColor={STATUS_COLORS.planifie} orderDirection={handleShowOrderDirection} status="planifie" onChanged={handleOperationChanged} refreshTrigger={refreshTrigger} />,
    },
    {
      label: (
        <div className="tabLabel">
          <span className="tabDot" style={{ backgroundColor: STATUS_COLORS.enCours }}></span>
          <div>
            <b>En cours</b>
            <p>{countedCurrentData.numberOfOp || 0} {parseInt(countedCurrentData.numberOfOp) >= 2 ? 'opérations' : 'opération'}</p>
          </div>
        </div>
      ),
      key: 2,
      children: <OperationCardList fetchOperations={getAllCurrentOperationApi} statusColor={STATUS_COLORS.enCours} orderDirection={handleShowOrderDirection} status="enCours" onChanged={handleOperationChanged} refreshTrigger={refreshTrigger} />,
    },
    {
      label: (
        <div className="tabLabel">
          <span className="tabDot" style={{ backgroundColor: STATUS_COLORS.termine }}></span>
          <div>
            <b>Terminés</b>
            <p>{countedFinishedData.numberOfOp || 0} {parseInt(countedFinishedData.numberOfOp) >= 2 ? 'opérations' : 'opération'}</p>
          </div>
        </div>
      ),
      key: 3,
      children: <OperationCardList fetchOperations={getAllFinishedOperationApi} statusColor={STATUS_COLORS.termine} orderDirection={handleShowOrderDirection} status="termine" refreshTrigger={refreshTrigger} />,
    },
  ];

  return (
    <Fragment>
      <section className="OperationManagementSection">
        <div className="contents">
          <Row>
            <Col md="2" className="p-0">
              <SideBar />
            </Col>
            <Col md="10" className="p-0">
              <Header />
              <Row>
                <Col md="8" className="p-0">
                  <Tabs onChange={onChange} type="card" items={tabsData} />
                </Col>
                <Col md="4" className="p-0">
                  <div className="rightSideTabContent">
                    <p className="mapCaption">
                      {hasSelectedRoute ? "Itinéraire du trajet sélectionné" : "Sélectionnez un trajet pour visualiser l'itinéraire"}
                    </p>
                    <MapContainer
                      center={position}
                      zoom={13}
                      style={{ height: "72vh" }}
                    >
                      <TileLayer
                        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                      />
                      <MapComponent
                        startPoint={startPosition}
                        endPoint={endPosition}
                      />
                    </MapContainer>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </section>
    </Fragment>
  );
}

export default OperationManagement;
